/**
 * Cart Bundle — keeps all line items sharing a _bundleHash in sync.
 * - Quantity changes propagate to every key in data-bundle-keys.
 * - Remove zeroes-out every key at once.
 */
(function () {
  if (window.__cartBundleInit) return;
  window.__cartBundleInit = true;

  var ROUTES = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var UPDATE_URL = ROUTES + 'cart/update.js';

  function postUpdate(updates) {
    return fetch(UPDATE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates }),
    });
  }

  function buildUpdates(keys, qty) {
    var updates = {};
    keys.forEach(function (k) { if (k) updates[k] = qty; });
    return updates;
  }

  function refreshCart() {
    // Prefer existing handler refresh hooks if present, otherwise hard reload.
    if (window.__cartHandler && typeof window.__cartHandler.refresh === 'function') {
      window.__cartHandler.refresh();
      return;
    }
    var ev = new CustomEvent('cart:updated', { bubbles: true });
    document.dispatchEvent(ev);
    window.location.reload();
  }

  function getBundleEl(target) {
    return target.closest('bundle-cart-item');
  }

  function getKeys(bundleEl) {
    var attr = bundleEl.getAttribute('data-bundle-keys') || '';
    return attr.split(',').filter(Boolean);
  }

  function setBusy(bundleEl, busy) {
    bundleEl.toggleAttribute('aria-busy', !!busy);
    if (busy) {
      bundleEl.style.opacity = '0.6';
      bundleEl.style.pointerEvents = 'none';
    } else {
      bundleEl.style.opacity = '';
      bundleEl.style.pointerEvents = '';
    }
  }

  // Quantity sync
  document.addEventListener('click', function (e) {
    var inc = e.target.closest('[data-bundle-increase]');
    var dec = e.target.closest('[data-bundle-decrease]');
    if (!inc && !dec) return;

    var bundleEl = getBundleEl(e.target);
    if (!bundleEl) return;
    var input = bundleEl.querySelector('bundle-quantity input');
    if (!input) return;

    var current = parseInt(input.value, 10) || 1;
    var next = inc ? current + 1 : Math.max(1, current - 1);
    if (next === current) return;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (!input.matches('bundle-quantity input')) return;

    var bundleEl = getBundleEl(input);
    if (!bundleEl) return;

    var qty = Math.max(1, parseInt(input.value, 10) || 1);
    input.value = qty;
    var keys = getKeys(bundleEl);
    if (!keys.length) return;

    setBusy(bundleEl, true);
    postUpdate(buildUpdates(keys, qty))
      .then(function () { refreshCart(); })
      .catch(function (err) {
        console.error('[cart-bundle] qty update failed:', err);
        setBusy(bundleEl, false);
      });
  });

  // Remove all bundle keys
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bundle-remove]');
    if (!btn) return;
    var bundleEl = getBundleEl(btn);
    if (!bundleEl) return;

    var keys = getKeys(bundleEl);
    if (!keys.length) return;

    setBusy(bundleEl, true);
    postUpdate(buildUpdates(keys, 0))
      .then(function () { refreshCart(); })
      .catch(function (err) {
        console.error('[cart-bundle] remove failed:', err);
        setBusy(bundleEl, false);
      });
  });
})();
